import React from "react";
import {WerfenColor} from "../../../../Constants/ColorChart";
import "./DownloadManager.css";
import {IconContainer, TableData} from "../../../ResultTable/Components/ResultRow/StyledResultRow";
import FeatherIconWrapper from "../../../Icons/FeatherIconWrapper";
import DocumentDownload from "../../../../../Download/Entity/DocumentDownload";
import {
    DeleteDownloadIcon,
    DownDownloadIcon,
    PauseDownloadIcon,
    StartDownloadIcon,
    UpDownloadIcon
} from "../../../Icons/DownloadManager/DownloadManager";
import {connect} from "react-redux";
import isElectron from "is-electron";

type DownloadManagerColumnActionProps = {
    document: DocumentDownload;
    documents: DocumentDownload[];
}

let eventDispatcher: any = null;
if (isElectron()) {
    eventDispatcher = require('../../../../../Download/DependencyInjection/eventDispatcher').default();
}

const DownloadManagerColumnAction = (props: DownloadManagerColumnActionProps) => {
    const {document, documents} = props;
    const documentSorted: DocumentDownload[] = documents.sort(
        (firstDocument, secondDocument): number => {
            return firstDocument.getPosition() - secondDocument.getPosition()
        }
    );
    const firstPosition: number = documentSorted[0]?.getPosition() ?? 0;
    const countItems: number = documents.length - 1;
    const lastPosition: number = documentSorted[countItems]?.getPosition() ?? documentSorted.length;
    const currentPosition: number = document.getPosition();
    const canShowUpIcon: boolean = document.isPendingStatus() && currentPosition > (firstPosition + 1);
    const canShowDownIcon: boolean = document.isPendingStatus() && currentPosition > firstPosition && currentPosition < lastPosition;

    const pauseDownloadAction = (document: DocumentDownload): void => {
        eventDispatcher.dispatch('PauseDownload', document);
    }

    const resumeDownloadAction = (document: DocumentDownload): void => {
        eventDispatcher.dispatch('ResumeDownload', document);
    }

    const moveUpDownloadAction = (document: DocumentDownload): void => {
        eventDispatcher.dispatch('MoveUpDownload', document.getId());
    }

    const moveDownDownloadAction = (document: DocumentDownload): void => {
        eventDispatcher.dispatch('MoveDownDownload', document.getId());
    }

    const cancelDownloadAction = (document: DocumentDownload): void => {
        if (document.isDownloadingStatus()) {
            pauseDownloadAction(document);
        }

        if (window.confirm('This will cancel and remove the selected download')) {
            if (document.isDownloadingStatus()) {
                eventDispatcher.dispatch('CancelCurrentDownload', document);
                return;
            }

            eventDispatcher.dispatch('CancelDownload', document);
            return;
        }

        if (document.isDownloadingStatus()) {
            resumeDownloadAction(document);
        }
    }

    return (
        <TableData className="actions" width={"*"} textAlignRight>
            {document.canPause() && <IconContainer className={"iconContainer"}>
              <FeatherIconWrapper
                color={WerfenColor}
                fillColor={"none"}
                width={"30px"}
                iconStyle={{margin: "0px"}}
                fillSecondaryColor={null}
                onClick={(event: Event): void => {
                    event.preventDefault();
                    event.stopPropagation();
                    pauseDownloadAction(document);
                }}
                isActive={true}
                className={null}
                ariaLabel={"Pause Download"}
                role={null}
                Icon={PauseDownloadIcon}/>
            </IconContainer>}
            {document.canResume() && <IconContainer className={"iconContainer"}>
              <FeatherIconWrapper
                color={WerfenColor}
                fillColor={"none"}
                width={"30px"}
                iconStyle={{margin: "0px"}}
                fillSecondaryColor={null}
                onClick={(event: Event): void => {
                    event.preventDefault();
                    event.stopPropagation();
                    resumeDownloadAction(document);
                }}
                isActive={true}
                className={null}
                ariaLabel={"Resume Download"}
                role={null}
                Icon={StartDownloadIcon}/>
            </IconContainer>}
            {canShowUpIcon && <IconContainer className={"iconContainer"}>
              <FeatherIconWrapper
                color={WerfenColor}
                fillColor={"none"}
                width={"30px"}
                iconStyle={{margin: "0px"}}
                fillSecondaryColor={null}
                onClick={(event: Event): void => {
                    event.preventDefault();
                    event.stopPropagation();
                    moveUpDownloadAction(document);
                }}
                isActive={true}
                className={null}
                ariaLabel={"Up Download"}
                role={null}
                Icon={UpDownloadIcon}
              />
            </IconContainer>}
            {canShowDownIcon && <IconContainer className={"iconContainer"}>
              <FeatherIconWrapper
                color={WerfenColor}
                fillColor={"none"}
                width={"30px"}
                iconStyle={{margin: "0px"}}
                fillSecondaryColor={null}
                onClick={(event: Event): void => {
                    event.preventDefault();
                    event.stopPropagation();
                    moveDownDownloadAction(document);
                }}
                isActive={true}
                className={null}
                ariaLabel={"Down Download"}
                role={null}
                Icon={DownDownloadIcon}
              />
            </IconContainer>}
            {document.canCancel() && <IconContainer className={"iconContainer"}>
              <FeatherIconWrapper
                color={WerfenColor}
                fillColor={"none"}
                width={"30px"}
                iconStyle={{margin: "0px"}}
                fillSecondaryColor={null}
                onClick={(event: Event): void => {
                    event.preventDefault();
                    event.stopPropagation();
                    cancelDownloadAction(document);
                }}
                isActive={true}
                className={null}
                ariaLabel={"Cancel Download"}
                role={null}
                Icon={DeleteDownloadIcon}/>
            </IconContainer>}
        </TableData>
    );
}

export default connect(null, {})(DownloadManagerColumnAction);

